import React from 'react'
import { useI18n } from '../state/I18nContext'

const Story: React.FC = () => {
  const { t } = useI18n()
  const s = t.story
  return (
    <section className="max-w-6xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-2">{s.title}</h1>
      <p className="text-neutral-600 mb-8">{s.subtitle}</p>
      <div className="grid md:grid-cols-2 gap-6 mb-10">
        {s.paragraphs.map((p, i) => (
          <p key={i} className="leading-relaxed">{p}</p>
        ))}
      </div>
      <h2 className="text-2xl font-semibold mb-4">{s.processTitle}</h2>
      <ol className="list-decimal pl-6 space-y-2 mb-2">
        {s.processSteps.map((step, i) => (
          <li key={i}>{step}</li>
        ))}
      </ol>
      <p className="text-sm text-neutral-500">{s.processNote}</p>
    </section>
  )
}

export default Story
